export default {
  REVIEW: {
    label: 'RECLAIM_STAGE.IN_REVIEW',
    message: 'RECLAIM_STAGE.IN_REVIEW_MESSAGE',
  },
  AUTO_REVIEW: {
    label: 'RECLAIM_STAGE.IN_REVIEW',
    message: 'RECLAIM_STAGE.IN_REVIEW_MESSAGE',
  },
  MANUEL_REVIEW: {
    label: 'RECLAIM_STAGE.IN_REVIEW',
    message: 'RECLAIM_STAGE.IN_REVIEW_MESSAGE',
  },
  REVIEW_IBAN: {
    label: 'RECLAIM_STAGE.IN_REVIEW',
    message: 'RECLAIM_STAGE.IN_REVIEW_MESSAGE',
  },
  REVIEW_FILE: {
    label: 'RECLAIM_STAGE.IN_REVIEW',
    message: 'RECLAIM_STAGE.IN_REVIEW_MESSAGE',
  },
  RETURNED: {
    label: 'RECLAIM_STAGE.UPDATE_NEEDED',
    message: 'RECLAIM_STAGE.UPDATE_NEEDED_MESSAGE',
  },
  APPROVED: {
    label: 'RECLAIM_STAGE.SENT_TO_AUTHORITIES',
    message: 'RECLAIM_STAGE.SENT_TO_AUTHORITIES_MESSAGE',
  },
  RECLAIMED: {
    label: 'RECLAIM_STAGE.RECLAIMED',
    message: 'RECLAIM_STAGE.RECLAIMED',
  },
  SUBMITTED: {
    label: 'RECLAIM_STAGE.SUBMITTED',
    message: 'RECLAIM_STAGE.SUBMITTED_MESSAGE',
  },
  INVOICED: {
    label: 'RECLAIM_STAGE.INVOICED',
    message: 'RECLAIM_STAGE.INVOICED_MESSAGE',
  },
  RECEIVED: {
    label: 'RECLAIM_STAGE.RECEIVED',
    message: 'RECLAIM_STAGE.RECEIVED_MESSAGE',
  },
  SENT: {
    label: 'RECLAIM_STAGE.SENT',
    message: 'RECLAIM_STAGE.SENT_MESSAGE',
  },
}
